import { FormDataService } from '../data.service';
import { FormShareService } from '../share.service';
import { FormStatusService } from '../status.service';
import { SwalService } from '../../../fastlane-common/services/swal.service';
import { SaveCreditsFormActionHandlerService } from './save-credits.service';
import { UserContextService } from '../../../user/services/user-context.service';
import { EmailService } from '../../../email/services/email.service';
import { PublishSubscribeService } from '../../../fastlane-common/services/publish-subscribe.service';
import { SignaturesManageService } from '../../../management/signatures/manage/manage.service';
import { AttachmentsService } from '../../../project/services/attachments.service';
import { NavService } from '../../../fastlane-common/services/nav.service';
import * as i0 from "@angular/core";
import * as i1 from "../../../project/services/attachments.service";
import * as i2 from "../data.service";
import * as i3 from "../share.service";
import * as i4 from "../status.service";
import * as i5 from "../../../fastlane-common/services/swal.service";
import * as i6 from "../../../user/services/user-context.service";
import * as i7 from "../../../management/signatures/manage/manage.service";
import * as i8 from "../../../email/services/email.service";
import * as i9 from "../../../fastlane-common/services/publish-subscribe.service";
import * as i10 from "../../../fastlane-common/services/nav.service";
export class ResendInitialCertLetterService extends SaveCreditsFormActionHandlerService {
    constructor(attachmentService, dataService, formShareService, statusService, swalService, userContextService, esignService, emailService, pubSubService, navService) {
        super(attachmentService, dataService, formShareService, statusService, swalService, userContextService, emailService, pubSubService, navService);
        this.attachmentService = attachmentService;
        this.esignService = esignService;
        this.navService = navService;
    }
    exec() {
        const that = this;
        return new Promise((resolve, reject) => {
            super
                .exec()
                .then(() => {
                that.esignService
                    .cancelAgreement(that.formShareService.form.projectAgreementId)
                    .subscribe(() => {
                    that.swalService.dismiss();
                    that.swalService.load('Resending the Letter....');
                    that.esignService
                        .resendAgreement(that.formShareService.form.projectAgreementId)
                        .subscribe(() => {
                        that.swalService.success({
                            title: 'Initial Certification Letter has been Resent for Signature successfully!!'
                        });
                    });
                });
            })
                .catch(() => { });
        });
    }
}
ResendInitialCertLetterService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ResendInitialCertLetterService_Factory() { return new ResendInitialCertLetterService(i0.ɵɵinject(i1.AttachmentsService), i0.ɵɵinject(i2.FormDataService), i0.ɵɵinject(i3.FormShareService), i0.ɵɵinject(i4.FormStatusService), i0.ɵɵinject(i5.SwalService), i0.ɵɵinject(i6.UserContextService), i0.ɵɵinject(i7.SignaturesManageService), i0.ɵɵinject(i8.EmailService), i0.ɵɵinject(i9.PublishSubscribeService), i0.ɵɵinject(i10.NavService)); }, token: ResendInitialCertLetterService, providedIn: "root" });
